<template>
  <!-- 打印 -->
  <div>
    <el-dialog
      :title="$t('functionBtn.print')"
      :visible.sync="dialogVisible"
      width="800px"
      class="splitDialog"
      @close="close"
    >
      <upload :printShow="true" :tableData="tableData || []" @uploadPrint="uploadPrint" />
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="close" class="fixed-bottom-btn"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <Print ref="easyPrint">
      <print-demo :content="content"></print-demo>
    </Print>
  </div>
</template>
<script>
  import API from '@/api/wareHouse/mcInbound.js';
  import upload from '@/components/upload';
  import printDemo from '@/components/Print/printDemo';
  import Print from '@/components/Print';

  export default {
    props: {
      id: {
        type: String,
        default: '',
      },
      deleveryFlag: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      upload,
      printDemo,
      Print,
    },
    data() {
      return {
        dialogVisible: false,
        tableData: [],
        content: '',
      };
    },
    methods: {
      // 打开
      openDialog() {
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        const params = {
          handleClass: 'print',
          moduleCode: 'mcBill',
          templateCode: 'mcBillPrint',
        };
        this.$axios.post(API.GET_FILE, params).then((res) => {
          if (res.data.code === 0) {
            this.tableData = res.data.data || [];
            if (!this.deleveryFlag) {
              // this.tableData=this.tableData.filter(it => it.attachmentName.indexOf('提单')>-1);
            }
          }
        });
      },
      //打印或下载
      uploadPrint(val, type) {
        this.loading.startLoading();
        const params = {
          dataNo: this.id,
          downloadOrPrint: type == 1 ? 'print' : 'download',
          templateUrl: val.attachmentKey,
        };
        this.$axios.post(API.EXPORT_PRINT, params).then((res) => {
          if (res.data.code === 0) {
            this.loading.endLoading();
            if (type == 1) {
              if (res.data.data.pdf) {
                // window.location.href = res.data.data.pdf;
                window.open(res.data.data.pdf, '_blank');
              } else if (res.data.data.excel) {
                this.content = res.data.data.excel || '';
                setTimeout(() => {
                  this.$refs.easyPrint.print();
                }, 500);
              }
            } else {
              window.location.href = res.data.data.word;
            }
          } else {
            this.loading.endLoading();
            this.$alert(res.data.msg);
          }
        });
      },

      showTip(tip) {
        this.$message({
          showClose: true,
          message: tip,
          type: 'error',
        });
      },
      // 弹窗关闭
      close() {
        this.dialogVisible = false;
      },
    },
  };
</script>
